export default __webpack_public_path__ + "2ea41f8d5df8020b36313aa0ea7b4f2f.png";